// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xaY7q","tableContainer":"styles_tableContainer__Fv56M"};